export default {
  from: 'from',
  to: 'to',
} as const;
